import { useState, useMemo } from 'react';

// 정렬 훅
export function useSortable(data, defaultKey = null, defaultDir = 'asc') {
  const [sortKey, setSortKey] = useState(defaultKey);
  const [sortDir, setSortDir] = useState(defaultDir);

  const sorted = useMemo(() => {
    if (!sortKey) return data;
    return [...data].sort((a, b) => {
      let va = a[sortKey], vb = b[sortKey];
      if (va == null) va = '';
      if (vb == null) vb = '';
      // 숫자 비교
      if (typeof va === 'number' || (!isNaN(Number(va)) && va !== '')) {
        const diff = Number(va) - Number(vb);
        return sortDir === 'asc' ? diff : -diff;
      }
      // 문자열 비교
      const cmp = String(va).localeCompare(String(vb), 'ko');
      return sortDir === 'asc' ? cmp : -cmp;
    });
  }, [data, sortKey, sortDir]);

  const toggleSort = (key) => {
    if (sortKey === key) setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    else { setSortKey(key); setSortDir('asc'); }
  };

  const SortIcon = ({ col }) => (
    <span className={`sort-icon${sortKey === col ? ' active' : ''}`}>
      {sortKey === col ? (sortDir === 'asc' ? '▲' : '▼') : '⇅'}
    </span>
  );

  return { sorted, sortKey, sortDir, toggleSort, SortIcon };
}

// 페이지네이션 훅
export function usePagination(data, pageSize = 20) {
  const [page, setPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(data.length / pageSize));
  const currentPage = Math.min(page, totalPages);

  const paged = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return data.slice(start, start + pageSize);
  }, [data, currentPage, pageSize]);

  // 데이터 변경 시 페이지 리셋
  const resetPage = () => setPage(1);

  const Pager = () => {
    if (totalPages <= 1) return null;
    const start = Math.max(1, currentPage - 2);
    const end = Math.min(totalPages, currentPage + 2);
    return (
      <div className="pagination">
        <button disabled={currentPage <= 1} onClick={() => setPage(1)}>«</button>
        <button disabled={currentPage <= 1} onClick={() => setPage(p => p - 1)}>‹</button>
        {start > 1 && <span className="page-info">...</span>}
        {Array.from({ length: end - start + 1 }, (_, i) => start + i).map(p => (
          <button key={p} className={p === currentPage ? 'active' : ''} onClick={() => setPage(p)}>{p}</button>
        ))}
        {end < totalPages && <span className="page-info">...</span>}
        <button disabled={currentPage >= totalPages} onClick={() => setPage(p => p + 1)}>›</button>
        <button disabled={currentPage >= totalPages} onClick={() => setPage(totalPages)}>»</button>
        <span className="page-info">{data.length}건 중 {(currentPage-1)*pageSize+1}-{Math.min(currentPage*pageSize, data.length)}</span>
      </div>
    );
  };

  return { paged, page: currentPage, totalPages, setPage, resetPage, Pager };
}
